/* Contribution codes are checkout-only; retain unrelated promotional codes. */
(function () {
  'use strict';
  const contributionCodes = new Set(['REGULAR', 'COMMUNITY']);
  function appliedCodes(cart) {
    const codes = new Set((cart.discount_codes || []).map(entry => typeof entry === 'string' ? entry : entry.code).filter(Boolean));
    const applications = [...(cart.cart_level_discount_applications || [])];
    for (const item of cart.items || []) {
      for (const allocation of item.line_level_discount_allocations || []) applications.push(allocation.discount_application);
    }
    for (const application of applications) {
      if (application?.type === 'discount_code' && application.title) codes.add(application.title);
    }
    return [...codes];
  }
  let running = false;
  async function reset() {
    const container = document.querySelector('[data-cart-contribution-reset]');
    if (!container || running) return;
    running = true;
    const form = container.querySelector('form');
    const status = container.querySelector('[data-cart-reset-status]');
    if (form) { form.inert = true; form.setAttribute('aria-busy', 'true'); }
    const cartPath = container.dataset.cartPath;
    try {
      const response = await fetch(`${cartPath}.js`, {cache: 'no-store', credentials: 'same-origin'});
      if (!response.ok) throw new Error('cart check failed');
      const cart = await response.json();
      const codes = appliedCodes(cart);
      if (codes.some(code => contributionCodes.has(code.toUpperCase()))) {
        const keep = codes.filter(code => !contributionCodes.has(code.toUpperCase()));
        status.hidden = false;
        status.textContent = 'removing the previous contribution code…';
        const note = form?.elements.note?.value ?? cart.note ?? '';
        const updated = await fetch(`${cartPath}/update.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({discount: keep.join(','), note})
        });
        if (!updated.ok) throw new Error('reset failed');
        const result = await updated.json();
        if (appliedCodes(result).some(code => contributionCodes.has(code.toUpperCase()))) throw new Error('code remains');
        // Reload the native cart so totals and Shopify line-removal keys agree.
        window.location.replace(cartPath);
        return;
      }
      status.hidden = true;
    } catch (_) {
      status.hidden = false;
      status.textContent = 'we couldn’t refresh your contribution discount. please reload the cart before continuing, or remove REGULAR / COMMUNITY at checkout.';
    } finally {
      if (form) { form.inert = false; form.removeAttribute('aria-busy'); }
      running = false;
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {appliedCodes};
  if (typeof document !== 'undefined') {
    reset();
    window.addEventListener('pageshow', event => { if (event.persisted) reset(); });
    document.addEventListener('shopify:section:load', reset);
  }
})();
